import { Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { StyledProfileNavItem } from "views/ClientProfile/styles";

function Nav() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const currentURL = window.location.href;
  const handleClick = (path) => {
    navigate(path);
  };

  const parts = currentURL.split("/");
  const url = parts[parts.length - 2];

  return (
    <>
      <Box
        mb={1}
        display="flex"
        gap="15px"
        flexWrap="wrap"
        justifyContent="center"
        alignItems="center"
        bgcolor="#F5F5F5"
      >
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname === `/atom-pro/income-tax-tan/incometax/${params.incometaxid}` ? 1 : 0
          }
          onClick={() => handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}`)}
        >
          Basic Info
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname === `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/challan`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/challan`)
          }
        >
          e-Challan
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname === `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/my-cas`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/my-cas`)
          }
        >
          AR (CA)
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname === `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/form`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/form`)
          }
        >
          Forms
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname ===
            `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/proceedings-excel`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(
              `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/proceedings-excel`
            )
          }
        >
          e-Proceedings Excel Overview
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname ===
            `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/traces-communication`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(
              `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/traces-communication`
            )
          }
        >
          Traces Inbox
        </StyledProfileNavItem>
         <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname ===
            `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/demand`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(
              `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/demand`
            )
          }
        >
          Traces Outstanding Demand
        </StyledProfileNavItem>
        {/* <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname ===
            `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/activity`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/activity`)
          }
        >
          Activity Log
        </StyledProfileNavItem>
        <StyledProfileNavItem
          variant="body1"
          color="rgba(0,0,0,0.7)"
          active={
            location.pathname ===
            `/atom-pro/income-tax-tan/incometax/${params.incometaxid}/client-status`
              ? 1
              : 0
          }
          onClick={() =>
            handleClick(`/atom-pro/income-tax-tan/incometax/${params.incometaxid}/client-status`)
          }
        >
          Sync Status
        </StyledProfileNavItem> */}
      </Box>
      {/* <Divider sx={{ borderBottomWidth: 1, }} /> */}
    </>
  );
}

export default Nav;
